export default "__VITE_ASSET__cfd1a241__"